export const environment = {
  environmentName: 'dev',
  production: false,
  authMode: 'bff',
  backend: {
    baseUrl: '',
    apiUrl: '/api',
  },
  identity: {
    ciamTenantId: 'e1e712ff-4188-4cad-8944-02d8934c0743'
  },
  appInsights: {
    instrumentationKey: '',
  },
  // MSAL configuration for employee authentication
  msal: {
    clientId: 'be25041e-258a-49c4-98e4-355bd43ac3f4', // Nlc-Frontend-Dev
    authority: 'https://login.microsoftonline.com/899780ab-82ce-4584-8742-3e870500bb0f',
    redirectUri: 'https://dev.nlc.niclen.de/redirect',
    scopes: ['openid', 'profile', 'email'],
    apiScopes: ['api://e7926aa9-1533-4971-9cea-facf1c44f630/access_as_user'] // Replace with your backend API scope
  },
  // MSAL configuration for customers (CIAM)
  msalCustomer: {
    clientId: 'e661774c-f964-4df8-83b0-cb600ddfe309', // same as local config
    authority: 'https://niclenkunden.ciamlogin.com/e1e712ff-4188-4cad-8944-02d8934c0743/v2.0',
    knownAuthorities: ['e1e712ff-4188-4cad-8944-02d8934c0743.ciamlogin.com'],
    redirectUri: 'https://dev.nlc.niclen.de/redirect',
    scopes: ['openid', 'profile', 'email'],
    apiScopes: ['api://c9a84929-77db-41f9-936c-93085893b94e/customer.own.access']
  },
  auth: {
    useSessionStorage: false
  },
  // appRegistration removed (no longer used)
};
